
import Header from '@/components/Header.vue'

export default {
	components: {
		Header
	}
}
